$(document).ready(function () {
  var windowWidth = $(window).width(); 
 const sliderblock = $('.pro-bundle-items-wrap-block');
      var sliderln = $('.pro-bundle-items-wrap-block .pro-bundle-item').length;
      var slidesToShowValue;
    if (sliderln == 3) {
        slidesToShowValue = 2;
    } else {
        slidesToShowValue = 3;
    }
      sliderblock.slick({
        slidesToShow: slidesToShowValue,
        slidesToScroll: 1,
        dots: true,
        infinite: true,
        autoplay: false,
        arrows: true,
         prevArrow: '<button type="button" class="slick-prev"><svg xmlns="http://www.w3.org/2000/svg" width="41" height="41" viewBox="0 0 41 41" fill="none"><circle cx="20" cy="20" r="20" transform="matrix(-1 0 0 1 40.5 0.426758)" fill="white"/><circle cx="20" cy="20" r="19.5" transform="matrix(-1 0 0 1 40.5 0.426758)" stroke="#14323C" stroke-opacity="0.5"/><path d="M22.5408 14.3047L16.0102 20.8353L22.5408 27.3659" stroke="#14323C" stroke-width="1.5"/></svg></button>', 
        nextArrow: '<button type="button" class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" width="41" height="41" viewBox="0 0 41 41" fill="none"><circle cx="20.5" cy="20.4268" r="20" fill="white"/><circle cx="20.5" cy="20.4268" r="19.5" stroke="#14323C" stroke-opacity="0.5"/><path d="M18.4592 14.3047L24.9898 20.8353L18.4592 27.3659" stroke="#14323C" stroke-width="1.5"/></svg></button>',
        responsive: [
    {
      breakpoint: 1024,
      settings: {
        arrows: true,
        slidesToShow: 3
      }
    },
    {
      breakpoint: 990,
      settings: {
        arrows: true,
        slidesToShow: 2
      }
    },
    {
      breakpoint: 480,
      settings: {
        arrows: true,
        slidesToShow: 1
      }
    },
  ]
      });
  const sliderbundle = $('.section-pro-bundle .pro-bundle-wrap-section.pro-bundle-wrap-bundle');
  slidercourseln = $('.section-pro-bundle .pro-bundle-wrap-section.pro-bundle-wrap-bundle .pro-bundle-course-item').length;
 if (slidercourseln > 4 && windowWidth > 991 ) {
   sliderbundle.slick({
     slidesToShow: 4,
     slidesToScroll: 1,
     dots: true,
     infinite: true,
     autoplay: false,
     arrows: true,
      prevArrow: '<button type="button" class="slick-prev"><svg xmlns="http://www.w3.org/2000/svg" width="41" height="41" viewBox="0 0 41 41" fill="none"><circle cx="20" cy="20" r="20" transform="matrix(-1 0 0 1 40.5 0.426758)" fill="white"/><circle cx="20" cy="20" r="19.5" transform="matrix(-1 0 0 1 40.5 0.426758)" stroke="#14323C" stroke-opacity="0.5"/><path d="M22.5408 14.3047L16.0102 20.8353L22.5408 27.3659" stroke="#14323C" stroke-width="1.5"/></svg></button>',
     nextArrow: '<button type="button" class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" width="41" height="41" viewBox="0 0 41 41" fill="none"><circle cx="20.5" cy="20.4268" r="20" fill="white"/><circle cx="20.5" cy="20.4268" r="19.5" stroke="#14323C" stroke-opacity="0.5"/><path d="M18.4592 14.3047L24.9898 20.8353L18.4592 27.3659" stroke="#14323C" stroke-width="1.5"/></svg></button>',
     responsive: [
       {
         breakpoint: 1024,
         settings: {
           arrows: true,
           slidesToShow: 2
         }
       },
       {
         breakpoint: 990,
         settings: {
           arrows: true,
           slidesToShow: 1
         }
       },
       {
         breakpoint: 480,
         settings: {
           arrows: true,
           slidesToShow: 1
         }
       }
   ]
 });
 }
  else if(windowWidth < 990) {
    sliderbundle.slick({
     slidesToShow: 1,
     slidesToScroll: 1,
     dots: true,
     infinite: true,
     autoplay: false,
     arrows: true,
      prevArrow: '<button type="button" class="slick-prev"><svg xmlns="http://www.w3.org/2000/svg" width="41" height="41" viewBox="0 0 41 41" fill="none"><circle cx="20" cy="20" r="20" transform="matrix(-1 0 0 1 40.5 0.426758)" fill="white"/><circle cx="20" cy="20" r="19.5" transform="matrix(-1 0 0 1 40.5 0.426758)" stroke="#14323C" stroke-opacity="0.5"/><path d="M22.5408 14.3047L16.0102 20.8353L22.5408 27.3659" stroke="#14323C" stroke-width="1.5"/></svg></button>',
     nextArrow: '<button type="button" class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" width="41" height="41" viewBox="0 0 41 41" fill="none"><circle cx="20.5" cy="20.4268" r="20" fill="white"/><circle cx="20.5" cy="20.4268" r="19.5" stroke="#14323C" stroke-opacity="0.5"/><path d="M18.4592 14.3047L24.9898 20.8353L18.4592 27.3659" stroke="#14323C" stroke-width="1.5"/></svg></button>'
 });
  }
const slidersimilar = $('.section-pro-similar-course .pro-bundle-wrap-similar');
var similar_section_ln = $('.section-pro-similar-course .pro-similar-course-item').length;

if (similar_section_ln > 4 && windowWidth > 991 ) {
  slidersimilar.slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    dots: true,
    infinite: true,
    arrows: true,
    prevArrow: '<button type="button" class="slick-prev"><svg xmlns="http://www.w3.org/2000/svg" width="41" height="41" viewBox="0 0 41 41" fill="none"><circle cx="20" cy="20" r="20" transform="matrix(-1 0 0 1 40.5 0.426758)" fill="white"/><circle cx="20" cy="20" r="19.5" transform="matrix(-1 0 0 1 40.5 0.426758)" stroke="#14323C" stroke-opacity="0.5"/><path d="M22.5408 14.3047L16.0102 20.8353L22.5408 27.3659" stroke="#14323C" stroke-width="1.5"/></svg></button>',
    nextArrow: '<button type="button" class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" width="41" height="41" viewBox="0 0 41 41" fill="none"><circle cx="20.5" cy="20.4268" r="20" fill="white"/><circle cx="20.5" cy="20.4268" r="19.5" stroke="#14323C" stroke-opacity="0.5"/><path d="M18.4592 14.3047L24.9898 20.8353L18.4592 27.3659" stroke="#14323C" stroke-width="1.5"/></svg></button>',
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          arrows: true,
          slidesToShow: 2
        }
      },
      {
        breakpoint: 990,
        settings: {
          arrows: true,
          slidesToShow: 1
        }
      },
      {
        breakpoint: 480,
        settings: {
          arrows: true,
          slidesToShow: 1
        }
      }
    ]
  });
} else if(windowWidth < 990) {
   slidersimilar.slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: true,
    infinite: true,
    arrows: true,
    prevArrow: '<button type="button" class="slick-prev"><svg xmlns="http://www.w3.org/2000/svg" width="41" height="41" viewBox="0 0 41 41" fill="none"><circle cx="20" cy="20" r="20" transform="matrix(-1 0 0 1 40.5 0.426758)" fill="white"/><circle cx="20" cy="20" r="19.5" transform="matrix(-1 0 0 1 40.5 0.426758)" stroke="#14323C" stroke-opacity="0.5"/><path d="M22.5408 14.3047L16.0102 20.8353L22.5408 27.3659" stroke="#14323C" stroke-width="1.5"/></svg></button>',
    nextArrow: '<button type="button" class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" width="41" height="41" viewBox="0 0 41 41" fill="none"><circle cx="20.5" cy="20.4268" r="20" fill="white"/><circle cx="20.5" cy="20.4268" r="19.5" stroke="#14323C" stroke-opacity="0.5"/><path d="M18.4592 14.3047L24.9898 20.8353L18.4592 27.3659" stroke="#14323C" stroke-width="1.5"/></svg></button>'
  });
}

const sliderbestseller = $('.product-best-section .pro-bundle-wrap-bestseller');
  var bestln = $('.product-best-section .pro-bestseller-item').length;
  if(bestln > 4 && windowWidth > 991){
sliderbestseller.slick({
  slidesToShow: 4,
  slidesToScroll: 1,
  dots: true,
  infinite: true,
  arrows: true,
   prevArrow: '<button type="button" class="slick-prev"><svg xmlns="http://www.w3.org/2000/svg" width="41" height="41" viewBox="0 0 41 41" fill="none"><circle cx="20" cy="20" r="20" transform="matrix(-1 0 0 1 40.5 0.426758)" fill="white"/><circle cx="20" cy="20" r="19.5" transform="matrix(-1 0 0 1 40.5 0.426758)" stroke="#14323C" stroke-opacity="0.5"/><path d="M22.5408 14.3047L16.0102 20.8353L22.5408 27.3659" stroke="#14323C" stroke-width="1.5"/></svg></button>',
  nextArrow: '<button type="button" class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" width="41" height="41" viewBox="0 0 41 41" fill="none"><circle cx="20.5" cy="20.4268" r="20" fill="white"/><circle cx="20.5" cy="20.4268" r="19.5" stroke="#14323C" stroke-opacity="0.5"/><path d="M18.4592 14.3047L24.9898 20.8353L18.4592 27.3659" stroke="#14323C" stroke-width="1.5"/></svg></button>',
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        arrows: true,
        slidesToShow: 2
      }
    },
    {
      breakpoint: 990,
      settings: {
        arrows: true,
        slidesToShow: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        arrows: true,
        slidesToShow: 1
      }
    }
  ]
});
  } else if(windowWidth < 990) {
  sliderbestseller.slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  dots: true,
  infinite: true,
  arrows: true,
   prevArrow: '<button type="button" class="slick-prev"><svg xmlns="http://www.w3.org/2000/svg" width="41" height="41" viewBox="0 0 41 41" fill="none"><circle cx="20" cy="20" r="20" transform="matrix(-1 0 0 1 40.5 0.426758)" fill="white"/><circle cx="20" cy="20" r="19.5" transform="matrix(-1 0 0 1 40.5 0.426758)" stroke="#14323C" stroke-opacity="0.5"/><path d="M22.5408 14.3047L16.0102 20.8353L22.5408 27.3659" stroke="#14323C" stroke-width="1.5"/></svg></button>',
  nextArrow: '<button type="button" class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" width="41" height="41" viewBox="0 0 41 41" fill="none"><circle cx="20.5" cy="20.4268" r="20" fill="white"/><circle cx="20.5" cy="20.4268" r="19.5" stroke="#14323C" stroke-opacity="0.5"/><path d="M18.4592 14.3047L24.9898 20.8353L18.4592 27.3659" stroke="#14323C" stroke-width="1.5"/></svg></button>'
});
  }
  $("#faq-search").on("keyup", function() {
    var value = $(this)
      .val()
      .toLowerCase();
    $(".set").filter(function() {
      $(this).toggle(
        $(this)
          .text()
          .toLowerCase()
          .indexOf(value) > -1
      );
    });
  });

  $("#faq-search").click(function() {
    $("html, body").animate(
      {
        scrollTop: $("#faq-search").offset().top
      },
      500
    );
  });
 $('.custom-customer-reviews').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true,
        infinite: true,
        autoplay: true,
        arrows: false,
        fade: true,
        cssEase: 'linear',
        rows:0,
        responsive: [
    {
      breakpoint: 1024,
      settings: {
        arrows: true,
        slidesToShow: 1
      }
    },
    {
      breakpoint: 990,
      settings: {
        arrows: true,
        slidesToShow: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        arrows: true,
        slidesToShow: 1
      }
    },
  ]
      });
  $(document).on('click','.btn-go-cart',function(){
      var pid = $(this).attr('data-id');
      var qty = $(this).attr('data-qty');
      var formData = {
        'id': pid,
        'quantity': qty
      }
      console.log(formData);
    $.ajax({
    type:'POST',
    url:'/cart/add.js',
    data:JSON.stringify(formData),
    dataType:'JSON',
    contentType:'application/json',
    success:function(data){
      window.location.href = '/cart';
    }
  });
    });

        $(document).on('click','.btn-section-addcart',function(){
      var pid = $(this).attr('data-id');
      var qty = $(this).attr('data-qty');
      var formData = {
        'id': pid,
        'quantity': qty
      }
      console.log(formData);
    $.ajax({
    type:'POST',
    url:'/cart/add.js',
    data:JSON.stringify(formData),
    dataType:'JSON',
    contentType:'application/json',
    success:function(data){
      window.location.href = '/cart';
    }
  });
    });

$(document).on('click', '.more-payopt-own', function(event) {
   $('.pdp-payment-icons.payment-icons').toggleClass('active');
});

});
